/*
 * @@Copyright (c): Knowdee All rights reserved.
 * @Description: vue-router 路由管理
 * @Author: wangwz@knowdee.com
 * @LastEditors: wangwz@knowdee.com
 * @Date: 2022-05-05 15:38:02
 * @LastEditTime: 2023-11-13 16:20:53
 * @FilePath: /client-h5-v2/src/router/index.ts
 */

import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import store from '@/store/index'


// 区分当前项目使用mobile端样式结构还是PC端样式结构
const routerToComponents = () => {
  // 获取sourcePage，如果是sourcePage=smallprog，返回mobile端样组件
  const sourcePage = store.getters['global/params'].sourcePage
  if (sourcePage === 'smallprog' || sourcePage === 'paasprogram') {
    return () => import('@/components-mobile/home/HomeIndex.vue')
  }

  // 设备名称
  const deviceName = store.getters['global/device']
  // 是否为移动手机
  const isMobilePhone = deviceName === 'mobile_phone'
  if (isMobilePhone) {
    return () => import('@/components-mobile/home/HomeIndex.vue')
  } else {
    return () => import('@/components-pc/home/HomeIndex.vue')
  }
}
const component = routerToComponents()

const routes: Array<RouteRecordRaw> = [
  {
    path: '/webview',
    name: 'webView',
    component: () => import('@/components-webview/layout/TheIndex.vue')
  },
  {
    path: '/',
    name: 'bot',
    component: component
  },
  {
    path: '/moli',
    name: 'moli',
    component: component
  },
  {
    path: '/lena',
    name: 'lena',
    component: component
  },
  {
    path: '/lmsa',
    name: 'lmsa',
    component: component
  },
  {
    path: '/lenovoapp',
    name: 'lenovoapp',
    component: component
  },
  {
    path: '/tablet',
    name: 'tablet',
    component: () => import('@/components-pc/home/HomeIndex.vue')
  },
  {
    path: '/helloyou',
    name: 'helloyou',
    component: () => import('@/components-pc/home/HomeIndex.vue')
  },
  {
    path: '/sitelecom',
    name: 'sitelecom',
    component: () => import('@/components-pc/home/HomeIndex.vue')
  },
  {
    path: '/forum',
    name: 'forum',
    component: component
  },
  {
    path: '/app',
    name: 'app',
    component: () => import('@/components-mobile/home/HomeIndex.vue')
  },
  {
    path: '/vantage',
    name: '/vantage',
    component: component
  },
  {
    path: '/teams',
    name: 'teams',
    component: component
  },
  {
    path: '/xiaole',
    name: 'xiaole',
    component: component
  },
  // 引导页面
  {
    path: '/guide',
    name: 'guide',
    component: () => import('@/components-special/ZhilianGuide.vue')
  },
  {
    path: '/zhilian',
    name: 'zhilian',
    component: component
  },
  {
    path: '/xiaole-pc',
    name: 'xiaolePc',
    component: () => import('@/components-pc/home/HomeIndex.vue')
  },
  {
    path: '/xiaole-mobile',
    name: 'xiaoleMobile',
    component: () => import('@/components-mobile/home/HomeIndex.vue')
  },
  {
    path: '/webinpage',
    name: 'webinpage',
    component: () => import('@/components-mobile/home/HomeIndex.vue')
  }
]

const router = createRouter({
  history: createWebHistory(window.botV2GlobalProperties.BASE_PATH),
  routes
})
router.beforeEach((to, from, next) => {
  next()
})
export default router
